<template>
<div>
    <label :for="`additionalResource-${ productResource.productId }`">{{ productResource.productName }}</label>
    <select class="form-control" 
        v-if="productResource.resources.length > 1"
        :value="selectedProductResourceId"
        @change="onSelect"
        :id="`additionalResource-${ productResource.productId }`">
        <option :value="null">{{ $_locale('select') }}</option>
        <option 
            v-for="(resource, index) in productResource.resources"
            :key="index"
            :disabled="resource.availableQuantity === 0"
            :value="resource.resourceId">{{ resource.resourceName }}
        </option>
    </select>
    <additional-resource ref="resource"
        :class="{ singular: singular }"
        v-show="singular === false"
        v-if="selectedProductResourceId !== null" 
        :resource="selectedProductResource" />
    <sub class="quantity-warning" style="color:red;" 
        v-show="productNotAvailable">
        {{ $_locale('product is out of stock') }}
    </sub>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import AdditionalResource from './AdditionalResource.vue'

export default {
    props: {
        productResource: {
            type: Object,
            required: true,
        },
        singular: {
            type: Boolean,
            default: false,
        }
    },
    components: {
        AdditionalResource
    },
    data: () => ({
        selectedProductResourceId: null,
        productNotAvailable: false,
    }),
    computed: {
        ...mapGetters({
        }),
        selectedProductResource() {
            const { resources } = this.productResource;

            return resources.filter(row => row.resourceId == this.selectedProductResourceId)[0];
        },
        resourcesAvailable() {
            const { resources } = this.productResource;

            return resources
                .filter(row => row.availableQuantity > 0)
                .map(row => row.resourceId).join(',');
        },
    },
    watch: {
        resourcesAvailable(val, oldVal) {
            if (val !== oldVal) {
                this.selectDefault();
            }
        }
    },
    methods: {
        onSelect(evt = null) {
            if (evt) {
                this.selectedProductResourceId = evt.target.value
            }
            
            this.$nextTick(() => {
                this.$refs.resource.adjustAdditionalResourceQuantity(true)
            })
        },
        selectDefault() {
            const { groupResourcesAsProducts } = this.$store.getters['reservations/settings'];
            const { resources } = this.productResource;

            // as per calendar store logic updateAvailableAdditionalResources: setDefaultQuantity = false
            if (groupResourcesAsProducts) return;

            this.selectedProductResourceId = null;

            for (let i = 0;i < resources.length;i++) {
                if (resources[i].availableQuantity > 0) {
                    this.selectedProductResourceId = resources[i].resourceId;
                    break;
                }
            }
            
            if (this.selectedProductResourceId !== null) {
                this.$nextTick(() => this.onSelect())
                this.productNotAvailable = false;
            } else {
                this.productNotAvailable = true;
            }
        },
    },
    mounted() {
        this.selectDefault();
    }
}
</script>